var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rating)?_c('p',{staticClass:"content-rating"},[(_vm.rating === 'explicit')?_c('span',[_vm._v("E"),_c('span',{staticClass:"sr-only"},[_vm._v("xplicit")])]):(_vm.rating === 'clean')?_c('span',[_vm._v("C"),_c('span',{staticClass:"sr-only"},[_vm._v("lean")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }